import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/custom_templates',
    name: 'CustomTemplate',
    component: {
      name: 'AdminCustomTemplate',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'custom_template',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminCustomTemplateIndex',
        component: () => import('../views/CustomTemplateIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminCustomTemplateNew',
        component: () => import('../views/CustomTemplateInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminCustomTemplateIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminCustomTemplateShow',
        component: () => import('../views/CustomTemplateShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminCustomTemplateIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminCustomTemplateDetails',
            component: () => import('../views/CustomTemplateDetails.vue'),
            meta: {
              backRoute: { name: 'AdminCustomTemplateIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminCustomTemplateEdit',
            component: () => import('../views/CustomTemplateInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminCustomTemplateDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminCustomTemplateAttachments',
            component: () => import('../views/CustomTemplateAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminCustomTemplatesIndex' },
              resource: 'attachment',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));